const ATOM = "[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+";
const LABEL = '[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?';
const TLD = '(?:[A-Za-z]{2,63}|xn--[A-Za-z0-9-]{0,58}[A-Za-z0-9])';

const EMAIL_PATTERN = new RegExp(`^${ATOM}(?:\\.${ATOM})*@(?:${LABEL}\\.)+${TLD}$`);

export const emailIsValid = (email: string): boolean => {
  const trimmed = email.trim();
  if (trimmed.length > 254 || trimmed.indexOf('@') > 64) return false;
  return EMAIL_PATTERN.test(trimmed);
};
